import * as Yup from 'yup';

import { merchantEmailSchema, personNameSchema } from './common';

export const merchantPhoneLoginSchema = Yup.object({
  phone: Yup.string()
    .test('us-phone', 'Enter a valid phone number', (value) => {
      if (!value) return false;
      const digits = String(value).replace(/\D/g, '');
      return /^1\d{10}$/.test(digits);
    })
    .required('Phone is required'),
  smsConsent: Yup.boolean()
    .oneOf([true], 'You must agree to receive SMS messages to continue')
    .required('You must agree to receive SMS messages to continue'),
});

export const otpSchema = Yup.object({
  otp: Yup.string()
    // .matches(/^\d{6}$/, 'Enter the 6-digit code')
    .required('OTP is required'),
});

export const createProfileSchema = Yup.object({
  firstName: Yup.string()
    .min(2, 'First name must be at least 2 characters')
    .max(50, 'First name must be at most 50 characters')
    .required('First name is required'),
  lastName: Yup.string()
    .min(2, 'Last name must be at least 2 characters')
    .max(50, 'Last name must be at most 50 characters')
    .required('Last name is required'),
  email: merchantEmailSchema,
  profileImage: Yup.mixed().nullable().optional(),
});

export const createTeamMemberSchema = Yup.object({
  firstName: personNameSchema('First name'),
  lastName: personNameSchema('Last name'),
  email: merchantEmailSchema,
});

export const teamMemberLookupSchema = Yup.object({
  phone: Yup.string()
    .test('us-phone', 'Enter a valid phone number', (value) => {
      if (!value) return false;
      const digits = String(value).replace(/\D/g, '');
      return /^1\d{10}$/.test(digits);
    })
    .required('Phone is required'),
});
